var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vl-main"},[_c("vlHeader",{tag:"div"}),_c('div',{staticClass:"vl-content"},[_c('router-view')],1),_c("vlFooter",{tag:"div"}),_c("imgZoom",{tag:"div"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }